// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_BAZAAR_GRID = "Zp\u011bt na inzer\u00e1ty";
export const BZ2_counter_PRODUCTS = ["%(counter)s inzer\u00e1t", "%(counter)s inzer\u00e1ty", "%(counter)s inzer\u00e1t\u016f"];
export const BZ2_ONLY_NOT_MARKED = "Jen nezkontrolovan\u00e9";
export const BZ2_ONLY_REPORTED = "Pouze nahl\u00e1\u0161en\u00e9";
export const PROFILE_username_BLOCKED_BY_USER = "U\u017eivatelka %(username)s u\u017e nem\u00e1 \u00fa\u010det na Modr\u00e9m kon\u00edku. K tomuto kroku se rozhodla a \u00fa\u010det si zru\u0161ila sama.";
